import type { CompareProduct } from '@iheartjane/menu';
// eslint-disable-next-line no-restricted-imports
import { useTabletMediaQuery } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { useIsCompareBarRevealed } from '@jane/bloom/components/compareProducts/compareBarVisibility';
import { useIsScrolling } from '@jane/bloom/hooks/useIsScrolling';

import { CompareProductButton } from './compareProductButton';

import styles from './comparePill.module.css';

interface ComparePillProps {
  compareProduct: CompareProduct;
}

/**
 * Mobile "Compare" button displayed above the add-to-bag fixed section.
 * Hides while the user is scrolling and comes back once the page settles.
 */
const MobileComparePill = ({ compareProduct }: ComparePillProps) => {
  const isScrolling = useIsScrolling();
  const isTabletUp = useTabletMediaQuery({});
  const isBarRevealed = useIsCompareBarRevealed();

  if (isTabletUp) return null;

  const isHidden = isScrolling || isBarRevealed;

  return (
    <CompareProductButton
      className={clsx(styles['pill'], {
        [styles['pill--hidden']]: isHidden,
      })}
      compareProduct={compareProduct}
      testId="compare-pill"
    />
  );
};

export const ComparePill = (props: ComparePillProps) => (
  <ClientOnly>{() => <MobileComparePill {...props} />}</ClientOnly>
);
